import gql from 'graphql-tag'
import { default as fragments } from './fragments'

// NOTE: uncomment if we're replacing localstorage with graphql global state
// export const QUERY_LOGGED_IN_USER gql`
//   query {
//     loggedInUser @client {
//       emailAddress
//       userDecodedID
//       userUUID
//       isPicsaEmployee
//       employer
//       responsibilities
//       identityResponsibilities
//     }
//   }
// `

export const QUERY_CONTACT = gql`
  query($identityId: UUID!) {
    contacts(identity_Id: $identityId) {
      edges {
        node {
          id
          employer {
            id
          }
        }
      }
    }
  }
`

export const QUERY_ACCOUNT_TYPE = gql`
  query {
    accounttypes {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`
export const QUERY_TRANSACTION_TYPE = gql`
  query {
    transactiontypes {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`
export const QUERY_TRANSACTION_STATUS = gql`
  query {
    transactionstatuses {
      edges {
        node {
          id
      		name
        }
      }
    }
  }
`
export const QUERY_EMPLOYERS = gql`
  query {
    employers(orderBy: "friendly_name") {
      edges {
        node {
          id
          friendlyName
        }
      }
    }
  }
`
export const QUERY_DIVISIONS_BY_EMPLOYER = gql`
  query($employer: UUID) {
    divisions(employer_Id: $employer) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`
export const QUERY_PAYROLLCYCLES_BY_EMPLOYER = gql`
  query($employer: UUID) {
    payrollcycles(employer_Id: $employer) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`
export const QUERY_EMPLOYERGROUPS = gql`
  query {
    employergroups(orderBy: "friendly_name") {
      edges {
        node {
          id
          friendlyName
        }
      }
    }
  }
`
export const QUERY_FILE = gql`
  query($id: ID!) {
    file(id: $id) {
      id
      asset
      url
      source
      trash
      children {
        edges {
          node {
            id
          }
        }
      }
      relations {
        edges {
          node {
            id
            objectId
            contentType {
              id
              model
            }
          }
        }
      }
    }
  }
`
export const QUERY_FILETYPE = gql`
  query {
    filetypes {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`
export const QUERY_REQUESTRUN = gql`
  query($id: ID!) {
    requestrun(id: $id) {
      ...RequestRun
    }
  }
  ${fragments.requestRun}
`
export const QUERY_REQUESTTYPE = gql`
  query($id: ID!) {
    requesttype(id: $id) {
      ...RequestType
    }
  }
  ${fragments.requestType}
`
export const QUERY_REQUESTTYPES = gql`
  query($audience: String, $source: String) {
    requesttypes(audience: $audience, source: $source) {
      edges {
        node {
          id
          name
          content
          audience
          workflow {
            id
          }
        }
      }
    }
  }
`
export const QUERY_CASERELATIONS = gql`
  query($objectId: UUID) {
    caserelations(objectId: $objectId, orderBy: "-created_at") {
      edges {
        node {
          id
          case {
            id
            priority
            productType
            requestType
            createdAt
            status
            nextActionAt
          }
        }
      }
    }
  }
`
export const QUERY_IDENTITIES_BY_IDENTITYVALUE = gql`
  query($identityValue: String!) {
    identities(identityValue: $identityValue) {
      edges {
        node {
          id
          firstName
          lastName
          identityValue
          isContact
          language
          addresses {
            edges {
              node {
                id
                addressType
                addressValue
                default
                optedOut
                inactive
              }
            }
          }
          client {
            id
            withdrawableAccounts
            withdrawableTargetProducts
            withdrawableTargetBankaccounts
            division {
              id
              name
              employer {
                id
                friendlyName
              }
            }
          }
        }
      }
    }
  }
`

export const QUERY_EMAIL = gql`
  query($id: ID!) {
    email(id: $id) {
      id
      fromAddr
      subject
      textBody
      toAddrs
      createdAt
      attachments {
        id
        asset
        url
        children {
          edges {
            node {
              id
              asset
              url
            }
          }
        }
      }
      toIdentities {
        id
        firstName
        lastName
      }
    }
  }
`

export const QUERY_WORKFLOWRUN_STEP_STATUS = gql`
  query($id: ID!, $atStep: Int!) {
    workflowrun(id: $id) {
      id
      workflowrunsteps(workflowstep_Number: $atStep) {
        edges {
          node {
            id
            status
          }
        }
      }
    }
  }
`

export const QUERY_MUTATE_WORKFLOWRUNSTEP = gql`
  mutation ($input: WorkflowRunStepMutationInput!) {
    workflowrunstepMutate(input: $input) {
      workflowrunstep {
        id
        status
      }
    }
  }
`

export const QUERY_EMPLOYER_SOLUTION = gql`
  query($identityId: ID!, $status: String!) {
    identity(id: $identityId) {
      id
      fullName
      employer {
        id
        employersolutions(status: $status) {
          edges {
            node {
              id
              activeAt
              billableEmployees
              deprecateAt
              solution {
                name
                participation
              }
            }
          }
        }
      }
    }
  }
`

export const QUERY_EMPLOYER_SOLUTION_PRODUCTS = gql`
  query($solution: UUID!, $orderBy: String) {
    employerproducts(employersolution_Id: $solution, orderBy: $orderBy) {
      edges {
        node {
          id
          activeAt
          billingType
          clientMatchingRequired
          clientMatchingRules
          costClient
          costEmployer
          deprecateAt
          discountOffBase
          employerShortCode
          exceptionRules
          product {
            name
            family
          }
        }
      }
    }
  }
`

export const QUERY_FILERELATIONS = gql`
  query($file: UUID!, $contentType: ID!) {
    filerelations(file_Id: $file, contentType_Id: $contentType, orderBy: "-created_at") {
      edges {
        node {
          id
          objectId
        }
      }
    }
  }
`

export const QUERY_PAYSLIPS = gql`
  query($identityId: UUID) {
    payslips(identity_Id: $identityId, orderBy: "-created_at") {
  		edges {
        node {
          id
          payday
          basicGross
          totalGross
          totalDeductions
          nonPicsaDebtDeductions
          loanapplication {
            id
          }
          creditapplications {
            edges {
              node {
                id
              }
            }
          }
          payrollrun {
            id
            workflowrunDeducting {
              id
            }
          }
          identity {
            id
            fullName
          }
        }
      }
    }
  }
`

export const QUERY_PAYSLIP = gql`
  query($id: ID!) {
    payslip(id: $id) {
      id
      payday
      basicGross
      totalDeductions
      nonPicsaDebtDeductions
      loanapplication {
        id
      }
      creditapplications {
        edges {
          node {
            id
            createdAt
            status
            amountAppliedFor
          }
        }
      }
      payrollrun {
        id
        payrollcycle {
          id
          name
        }
      }
      identity {
        id
        fullName
      }
    }
  }
`

export const QUERY_IDENTITY_BANKACCOUNTS = gql`
  query($uuid: UUID!, $status: String) {
    identitybankaccounts(identity_Id: $uuid, status: $status) {
      edges {
        node {
          ...IdentityBankAccount
        }
      }
    }
  }
  ${fragments.identityBankAccount}
`

export const QUERY_WITHDRAWAL_PRODUCTS = gql`
  query {
    withdrawalproducts {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`

export const QUERY_PRODUCT_NAMES_BY_FAMILY = gql`
  query($family: String) {
    products(family: $family) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`

export const QUERY_EMPLOYERPRODUCTS = gql`
  query($employerId: UUID!){
    employerproducts(employer_Id: $employerId) {
      edges {
        node {
          id
          product {
            id
            family
            name
          }
        }
      }
    }
  }
`

export const QUERY_CLIENTINVESTMENT = gql`
  query($id: ID!) {
    clientinvestment {
      id
      currentClientContribution
      currentEmployerContribution
      investedBalance
      processingBalance
      client {
        id
        identity {
          id
        }
      }
      employerproduct {
        id
        product {
          id
          family
          name
        }
      }
      instrument {
        id
        externalName
        instrumentType
      }

    }
  }
`

export const QUERY_CLIENTINVESTMENTPOLICIES = gql`
  query($clientInvestmentId: UUID, $orderBy: String) {
    clientinvestmentpolicies(clientinvestment_Id: $clientInvestmentId, orderBy: $orderBy) {
      edges {
        node {
          id
          amount
          activationOn
          deprecationOn
          liveStatus
          contributorType
          contributor {
            id
            fullName
          }
        }
      }
    }
  }
`

export const QUERY_PRODUCTS = gql`
  query($family: String) {
    products(family: $family) {
      edges {
        node {
          id
          name
          defaultShortCode
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/queries.js